<template>
    <div class="usercard" @click="edit(oUser)">
        <div class="picture">
            <img v-if="false" src="" alt=""> <!-- Se tiver imagem -->
            <p class="icon"><i class="fas fa-user-circle"></i></p> <!-- Se não tiver imagem -->
        </div>
        <div class="user-info">
            <p v-if="oUser.name" class="user-name">{{ oUser.name }}</p>
            <p class="user-alias">{{ oUser.username }}</p>
            <p class="user-type">{{ getRoleName(oUser.group) }}</p>
        </div>
    </div>
</template>
<script>
import UserAPI from '@/api/user'
import Group, { Role } from 'easyjs/lib/Role/Group'

import BaseTitle from '@/components/Title'
import BaseButton from '@/components/Button'
import BaseBox from '@/components/Box'
import BaseLabel from '@/components/Label'


export default {
  props: {
    showDelete: { type: Boolean, default: false },
    oUser: {},
    currentUser: {}
  },
  methods: {
      getRoleName: function(role) {
          if(Group.isAllowed(Role.MASTER, role)) {
              return StringLanguage.master
          } else if(Group.isAllowed(Role.ADMIN, role)) {
              return StringLanguage.administrator
          } else if(Group.isAllowed(Role.ATENDENTE, role)) {
              return StringLanguage.employee
          } else {
              return StringLanguage.unknown
          }
      },
      deleteUser: function(userId, event) {
        event.stopPropagation();

        // se o usuário tentar desvincular ele mesmo
        if (this.currentUser.id === userId) {
            alert(StringLanguage.unlinkOwnUserError);
            return false;
        }

        let self = this;
        confirm(StringLanguage.confirmDisassociateUser, (result) => {
            if(result) {
                UserAPI.disassociate(userId).then((response) => {
                    if(response.getErrors([]).length > 0){
                        alert(response.getErrors([])[0])
                    } else {
                        self.$emit("deleteUser", userId);
                    }
                }).catch((err) => {
                    console.log(err);
                    alert(StringLanguage.saveError)
                })
            }
        })

      },
      edit: function(selectedUser) {
        let self = this;

        // se o usuário tentar editar ele mesmo
        if (self.currentUser.id === selectedUser.id) {
            alert(StringLanguage.editOwnUserError);
            return false;
        }

        // se tentar editar o master
        if (selectedUser.group == Role.MASTER) {
            alert(StringLanguage.editUserMasterError);
            return false;
        }

        self.$emit("editUser", selectedUser);
      }
  },
  components: {
    BaseTitle,
    BaseButton,
    BaseBox,
    BaseLabel,
  }
}
</script>
<style scoped>
    .usercard-container {
        cursor: pointer;
    }

    .usercard {
        display: flex;
        align-items: center;
        width: 100%;
        position: relative;
    }

    .icon {
        font-size: 34px;
        color: var(--icon-inactive);
        margin-right: 25px;
    }

    .user-info {
        flex: 1;
    }

    .user-name {
        font-weight: bold;
        color: var(--label-primary);
        line-height: 17px;
        font-size: 1.4em;
        margin-bottom: 5px;
    }

    .user-alias {
        font-size: 1.2em;
        line-height: 15px;
        padding-bottom: 15px;
        margin-bottom: 15px;
        color: var(--label-primary);
        font-weight: 300;
        border-bottom: 1px solid #FFFFFF17;
    }

    .user-type{
        font-size: 1.2em;
        color: var(--label-primary);
        font-weight: bold;
    }
</style>

<style>

    .user-name p{
        max-width: 100%;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    }

</style>